<script setup>
/**
 * What a freight (LTL) quote needs when there are no packages behind it: the
 * pallets (a table) and the shipment's options - accessorials, site type,
 * commodity, insurance. Edits the object it is given: {units: [], freight: {}}.
 */
import {computed, set} from "vue";
import QuoteUnitsTable from "@/components/package/quote-units-table.vue";
import PackageFreightOptions from "@/components/package/package-freight-options.vue";

const props = defineProps({
  value: {type: Object, required: true},
})
const emits = defineEmits(['next'])

const shipment = computed(() => props.value)

if (!Array.isArray(shipment.value.units))
  set(shipment.value, 'units', [])
if (!shipment.value.freight)
  set(shipment.value, 'freight', {})
</script>

<template>
  <div>
    <quote-units-table freight :value="shipment.units" @next="emits('next')"/>
    <form-divider/>
    <package-freight-options quoting :value="shipment.freight"/>
  </div>
</template>
